import { useDraggable } from '@dnd-kit/core';
import { useTranslation } from 'react-i18next';

const DraggableWidget = (props) => {
    const { icon, id, label, formType, span } = props
    const { t } = useTranslation();
    
    const {
        attributes,
        listeners,
        setNodeRef,
        transform,
        isDragging,
    } = useDraggable({
        id: `widget-${id}`,
        data: {
            type: 'widget',
            id,
            label,
            formType,
            span,
            icon
        }
    });

    function getStyles(isDragging) {
        return {
            borderStyle: isDragging ? "dashed" : "solid",
            borderWidth: isDragging ? '2px' : '1px',
            opacity: isDragging ? 0.5 : 1,
            cursor: isDragging ? 'grabbing' : 'grab',
            transform: transform ? `translate3d(${transform.x}px, ${transform.y}px, 0)` : undefined,
        }
    }

    return (
        <>
            <div 
                ref={setNodeRef}
                className="widget-row"
                style={getStyles(isDragging)}
                {...listeners}
                {...attributes}
            >
                {icon}
                <div className="widget-label" style={{textTransform: "capitalize"}}>{t(label || id)}</div>
            </div>
        </>
    )

}

export default DraggableWidget